module.exports = __webpack_public_path__ + "img/color-2.d42a8cc.webp";